import React, { useState, useEffect, useRef } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  Character,
  CharacterSpell,
  CharacterAction,
  CharacterAbility,
  CharacterSheetInterface,
  Attack,
  CharacterItem,
  Ability,
  // CharacterWeapon,
} from "@dndModels";

// import API from "../../../utilities/system_api";
// import DataUtilities from '../../../utilities/common_utilities';
import DandDCharacterUtilities from "@dndUtilities/char_utilities";

import CharacterActionInput from "@dndComponents/character/spells_and_abilities/CharacterActionInput";

import ModalOrDrawer from "@components/display/ModalOrDrawer";
import CharacterSpellDetails from "@dndComponents/character/spells_and_abilities/CharacterSpellDetails";
import CharacterItemDetailsSidebar from "@dndComponents/character/inventory/CharacterItemDetailsSidebar";
import CharacterAttackSidebar from "@dndComponents/character/inventory/CharacterAttackSidebar";

interface Props {
  character: Character;
  char_interface: CharacterSheetInterface;
  shared?: boolean;
}

// const api = API.getInstance();
// const common_util = DataUtilities.getInstance();
const char_util = DandDCharacterUtilities.getInstance();

export default function CharacterPassives({
  character,
  char_interface,
  shared = false,
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [reloading_costs, setReloadingCosts] = useState(false);
  
  const [drawer, setDrawer] = useState("");
  const [details_action, setDetailsAction] = useState<CharacterAction | null>(null);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (!fetched) {
      character.subscription_holder.subscribe("Recalculated", mounted, recalculated);
      // console.log(id);
      setFetched(true);
    }
  });

  const recalculated = () => {
    // console.log("Actions");
    setReloading(true);
  }
  
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
     
  }, [reloading, setReloading]);
  
  useEffect(() => {
    if (reloading_costs) {
      setReloadingCosts(false);
    }
     
  }, [reloading_costs, setReloadingCosts]);

  const renderActionGroup = () => {
    const log_it = false; // group === "Actions"; // group === "Bonus Actions"; // 
    if (log_it) {
      console.log(char_interface.actions); // .filter(o => o.name.includes("Drink"))
      debugger;
    }
    // let filtered = char_interface.actions;
    let filtered = char_interface.actions.filter(o => o.is_passive);
    filtered = filtered.filter(o => 
      !(o.action instanceof CharacterAbility) || 
      !(o.action.the_ability instanceof Ability) ||
      o.action.the_ability.show_in.includes("Actions"));
    // filtered = filtered.filter(o => o.name.includes("Unseen"));
    if (log_it) {
      console.log(char_interface.actions);
      console.log(filtered);
      debugger;
    }
    if (filtered.length > 0) {
      return (
        <>
          <Grid
            style={{ fontWeight: "bold" }}
            container
            spacing={0}
            direction="row"
            size={{
              xs: 12
            }}>
            <Grid
              className="centered"
              size={{
                xs: 3
              }}>Name</Grid>
            <Grid
              container
              spacing={0}
              direction="row"
              size={{
                xs: 9
              }}>
              <Grid
                className="centered"
                size={{
                  xs: 3
                }}>When</Grid>
              <Grid
                className="centered"
                size={{
                  xs: 3
                }}>Range/Area</Grid>
              <Grid
                className="centered"
                size={{
                  xs: 3
                }}>Attack/DC</Grid>
              <Grid
                className="centered"
                size={{
                  xs: 3
                }}>Effect</Grid>
            </Grid>
          </Grid>
          { renderActionsOfType(filtered) }
        </>
      );
    } else return null;
  }

  const renderActionsOfType = (actions: CharacterAction[]) => {
    const log_it = false; // type === "Special"; // group === "Actions"; // 
    if (log_it) {
      console.log(actions);
      // actions = actions.filter(o => o.name.includes("Drink"));
      debugger;
    }
    return (
      <>
        { actions.map(action => {
          if (reloading) {
            return null;
          } else {
            return (
              <Grid
                key={action.true_id}
                size={{
                  xs: 12
                }}>
                <CharacterActionInput
                  char={character}
                  char_interface={char_interface}
                  action={action}
                  group={action.casting_time}
                  shared={shared}
                  level={action.level}
                  casting_time_cost
                  onOpen={() => {
                    setDetailsAction(action);
                    setDrawer("details");
                  }}
                />
              </Grid>
            );
          }
          })}
      </>
    );
  }

  const renderExtras = () => {
    const action = details_action;
    const open = drawer === "details";
    if (action && open) {
      // console.log(action);
      let char_item: CharacterItem | undefined = undefined;
      if (action.action instanceof CharacterItem) {
        char_item = action.action;
      } else {
        if (action.action instanceof CharacterAbility && action.action.item_id !== "") {
          const item_id = action.action.item_id;
          char_item = character.items.find(o => o.true_id === item_id);
        }
      }
      return (
        <>
          <ModalOrDrawer
            open={ drawer === "details" } 
            onClose={() => {
              setDrawer("");
              character.subscription_holder.modalClosed();
            }}>
            { char_item ? 
              <CharacterItemDetailsSidebar
                character={character}
                char_item={char_item}
                action={action}
                shared={shared}
                onRemove={() => {
                  character.changed();
                  character.subscription_holder.resourcesChanged();
                  char_util.repopulateCharFeatureBases(character);
                  setDrawer("");
                }}
                // onTransform={onTransform}
              /> 
            : (action.action instanceof CharacterSpell || 
              action.action instanceof CharacterAbility) ? 
              <CharacterSpellDetails
                character={character}
                char_interface={char_interface}
                obj={ action.action }
                level={ action.level }
                type={action.type}
                action={action}
                shared={shared}
                onObjChange={(obj: CharacterSpell | CharacterAbility) => {
                  if (obj instanceof CharacterSpell) {
                    const char = char_interface;
                    const spell_finder = char.spells.filter(o => o.true_id === obj.true_id);
                    if (spell_finder.length === 1) {
                      const char_spell = spell_finder[0];
                      char_spell.copy(obj);
                      char.subscription_holder.recalculate();
                      character.changed();
                    } else {
                      console.error("Spell Find Error:");
                      console.error(obj);
                      console.error(spell_finder);
                      console.error(char.spells);
                    }
                  } else {
                    const char = char_interface;
                    let ability_finder = char.abilities.filter(o => o.true_id === obj.true_id);
                    if (ability_finder.length === 0) {
                      ability_finder = char.spell_as_abilities.filter(o => o.true_id === obj.true_id);
                    }
                    if (ability_finder.length === 1) {
                      const char_ability = ability_finder[0];
                      char_ability.copy(obj);
                      char.subscription_holder.recalculate();
                      character.changed();
                    } else {
                      console.error("Ability Find Error:");
                      console.error(obj);
                      console.error(ability_finder);
                      console.error(char.abilities);
                    }
                  }
                }}
                onClose={() => {
                  setDrawer("");
                  // setLevel(null);
                }}
                // onTransform={() => {
                //   onTransform();
                // }}
                // onSourceChange={onCharChange}
              /> 
            : action.action instanceof Attack && 
              <CharacterAttackSidebar
                character={character}
                attack={action.action}
              />
            }
          </ModalOrDrawer>
        </>
      );
    }
    return null;
  }

  return (
    <Grid container spacing={0} direction="row" className="curved_border bg_black_transp">
      <Grid
        className="header centered"
        size={{
          xs: 12
        }}>
        Passive Effects
      </Grid>
      { renderActionGroup() }
      { renderExtras() }
    </Grid>
  );
}
